// removed by extract-text-webpack-plugin
module.exports = {"bg":"_2AjZC","base":"_2kYzp","sectionHeader":"_3nSNJ","title":"_1DQju","content":"_2Atwo","spinner":"_2qrAN","list":"_2G69B","fieldset":"_1djOU","form":"_1aZqe","group":"_3aPKn","footer":"_2hgrQ"};


//////////////////
// WEBPACK FOOTER
// ./src/views/PartnerReports/PartnerPlan/PartnerPlanDocumentDisplayForm.scss
// module id = 2569
// module chunks = 0